export default __webpack_public_path__ + "static/media/scenario1_table.dc7f12d8.svg";